/**
 * VisitStart-only IndexedDB queue for element/session writes when offline.
 * Idempotent (stable opId). Not a platform-wide offline framework.
 */

const DB_NAME = "visitstart-offline";
const DB_VERSION = 1;
const STORE = "ops";

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "opId" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export function makeVisitStartOpId(sessionId, kind, key) {
  return `${sessionId}:${kind}:${key}`;
}

export async function enqueueVisitStartOp(op) {
  const db = await openDb();
  const record = {
    opId: op.opId,
    sessionId: op.sessionId,
    kind: op.kind,
    payload: op.payload,
    createdAt: op.createdAt || new Date().toISOString(),
    attempts: op.attempts || 0,
  };
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(record);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  db.close();
  return record;
}

export async function listVisitStartOps(sessionId) {
  const db = await openDb();
  const rows = await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });
  db.close();
  if (!sessionId) return rows;
  return rows.filter((row) => row.sessionId === sessionId);
}

export async function removeVisitStartOp(opId) {
  const db = await openDb();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(opId);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  db.close();
}
